import type { IconNode } from '../types';

/**
 * @name frog-face
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiA3aC4wMSIgLz4KICA8Y2lyY2xlIGN4PSI2IiBjeT0iNyIgcj0iNCIgLz4KICA8cGF0aCBkPSJNMTQuNCA1LjNhMTAgMTAgMCAwIDAtNC44IDAiIC8+CiAgPGNpcmNsZSBjeD0iMTgiIGN5PSI3IiByPSI0IiAvPgogIDxwYXRoIGQ9Ik0xOCA3aC4wMSIgLz4KICA8cGF0aCBkPSJNMjIgMTMuNUMyMiAxNiAxNy41IDE4IDEyIDE4UzIgMTYgMiAxMy41IiAvPgogIDxwYXRoIGQ9Ik0xMCAxNGguMDEiIC8+CiAgPHBhdGggZD0iTTE0IDE0aC4wMSIgLz4KICA8cGF0aCBkPSJNMy4xIDkuNzVBNyA3IDAgMCAwIDIgMTMuNUMyIDE4LjIgNi41IDIyIDEyIDIyczEwLTMuOCAxMC04LjVhNyA3IDAgMCAwLTEuMS0zLjc1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/frog-face
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const frogFace: IconNode = [
  ['path', { d: 'M6 7h.01', key: 'dmwx2p' }],
  ['circle', { cx: '6', cy: '7', r: '4', key: '1ll67m' }],
  ['path', { d: 'M14.4 5.3a10 10 0 0 0-4.8 0', key: 'br48oe' }],
  ['circle', { cx: '18', cy: '7', r: '4', key: '18f4xa' }],
  ['path', { d: 'M18 7h.01', key: 'uqb172' }],
  ['path', { d: 'M22 13.5C22 16 17.5 18 12 18S2 16 2 13.5', key: '12esi5' }],
  ['path', { d: 'M10 14h.01', key: 'ssrbsk' }],
  ['path', { d: 'M14 14h.01', key: 'uax65s' }],
  [
    'path',
    {
      d: 'M3.1 9.75A7 7 0 0 0 2 13.5C2 18.2 6.5 22 12 22s10-3.8 10-8.5a7 7 0 0 0-1.1-3.75',
      key: 'hqvr1n',
    },
  ],
];

export default frogFace;
